@app.directive 'ssoForm', (ssoService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @visibleForm = if ssoService.isZendesk() then 'login' else 'signup'

    @login = =>
      @visibleForm = 'login'

    @signup = =>
      @visibleForm = 'signup'
    this

  controllerAs: 'ssoForm'
  templateUrl: "/assets/templates/directives/ssoForm/ssoForm.html"
